import React from 'react';
import styled from '@emotion/styled';
import IcomoonReact from 'icomoon-react';
import { useSelector, useDispatch } from 'react-redux';
import { push } from 'connected-react-router';

import Button from '../../../shared/_TBComponents/Button';
import iconSet from '../../../shared/images/teambuildr-selection.json';

const Container = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  padding: 40px 20px;
`;

const Card = styled('div')`
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.08);
  padding: 48px 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 500px;
  width: 100%;
  text-align: center;
`;

const IconArea = styled('div')`
  position: relative;
  margin-bottom: 28px;
`;

const IconCircle = styled('div')`
  width: 72px;
  height: 72px;
  background: #eceef2;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const LockBadge = styled('div')`
  position: absolute;
  bottom: -4px;
  right: -10px;
  width: 28px;
  height: 28px;
  background: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);
`;

const Heading = styled('p')`
  font-family: 'Nunito Sans';
  font-size: 20px;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 12px;
  line-height: 1.4;
`;

const Subtext = styled('p')`
  font-family: 'Nunito Sans';
  font-size: 14px;
  color: #6b7280;
  max-width: 380px;
  margin: 0 0 32px;
  line-height: 1.6;
`;

const NoGroupsMessage = () => {
  const currentUser = useSelector((state) => state.auth.data.currentUser);
  const isAthlete = currentUser?.admin === 0;
  const dispatch = useDispatch();

  return (
    <Container>
      <Card>
        <IconArea>
          <IconCircle>
            <IcomoonReact iconSet={iconSet} size={32} icon='Users' color='#9ba3af' />
          </IconCircle>
          <LockBadge>
            <IcomoonReact iconSet={iconSet} size={13} icon='lock' color='#9ba3af' />
          </LockBadge>
        </IconArea>
        <Heading>No group access yet</Heading>
        <Subtext>
          Your account doesn&apos;t have access to any groups. You&apos;ll need access to at least
          one group to build leaderboards. Contact your System Admin to get set up.
        </Subtext>
        <Button
          styledTextProps={{ fontWeight: 700, fontSize: 14, letterSpacing: '0px' }}
          name='Go Home'
          bgColor='#444444'
          txtColor='white'
          noBorder
          customBorderRadius='8px'
          onClick={() => dispatch(push(isAthlete ? '/workouts' : '/dashboard'))}
        />
      </Card>
    </Container>
  );
};

export default NoGroupsMessage;
